import api from "../util/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { BuscaComparativoResultadoModel } from "../models/comparativoResultado/buscaComparativoResultadoModel";

export const buscarComparativoResultado = createAsyncThunk("/ComparativoResultado/BuscarComparativoResultado", async (args: BuscaComparativoResultadoModel) => {
  try {
    const data = await api.get("/ComparativoResultado/BuscarComparativoResultado", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const buscarComparativoResultadoEmpresa = createAsyncThunk("/ComparativoResultado/BuscarComparativoResultadoEmpresa", async (idSorteio: number) => {
  try {
    const data = await api.get("/ComparativoResultado/BuscarComparativoResultadoEmpresa", {
      params: { idSorteio: idSorteio },
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const warningComparacaoResultadoSorteio = createAsyncThunk("/ComparativoResultado/WarningComparacaoResultadoSorteio", async (args: BuscaComparativoResultadoModel) => {
  try {
    const data = await api.get("/ComparativoResultado/WarningComparacaoResultadoSorteio", {
      params: args,
    });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});
